import React from "react";
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import { styled } from "@mui/material";

/**
 * A GridToolbarContainer that contains a GridToolbarExport. This is used
 * to provide a default export toolbar for DataGrid components.
 *
 * @returns {React.ReactElement} A GridToolbarContainer with a single
 *          GridToolbarExport component.
 */
export const ExportToolbar = () => {
  return (
    <ToolbarContainer>
      <GridToolbarExport
        printOptions={{
          hideFooter: true,
          hideToolbar: true,
        }}
      />
    </ToolbarContainer>
  );
};

const ToolbarContainer = styled(GridToolbarContainer)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
}));
